import { TaskItem } from '@domains/documents-review/interfaces/interfaces';

export const errorMessage = (message: string): string | null => {
  if (!message) return null;

  const match = message.match(/^the task is in status progress(.*)$/i);
  if (match) {
    const agentPart = match[1]?.trim();
    return `Tarea en progreso por el agente ${agentPart}`;
  }

  return null;
};

export const statusLabel: Record<string, JSX.Element> = {
  completed: (
    <div className="d-flex  gap-1 justify-content-center text-success">
      Finalizado
    </div>
  ),
  pending: <div className="d-flex gap-1 justify-content-center">Pendiente</div>,
  progress: (
    <div className="d-flex gap-1 justify-content-center text-warning">
      En progreso
    </div>
  ),
  rejected: (
    <div className="d-flex gap-1 justify-content-center text-danger">
      Rechazado
    </div>
  ),
};

export const statusText: Record<string, string> = {
  completed: 'Finalizado',
  pending: 'Pendiente',
  progress: 'En progreso',
  rejected: 'Rechazado',
};

export const BUSINESS_TYPE_LABELS = {
  real_estate: 'Inmobiliaria',
  committee: 'Market Maker',
};

export const BUSINESS_TYPE_OPTIONS = Object.entries(BUSINESS_TYPE_LABELS).map(
  ([value, label]) => ({ value, label })
);

const DEV_AGENTS = [
  'edwardmartinez@habi.co',
  'lauracanon@habi.co',
  'santiagosalcedo@habi.co',
  'cristianpalacios@tuhabi.mx',
  'felipeuribe@habi.co',
  'miguelcruz@habi.co',
  'carlosbaquero@habi.co',
  'jonathanmontoya@habi.co',
];

export const AGENT_LIST_DOCUMENT: Record<string, string[]> = {
  get CO() {
    return process.env.ENV_ORIGIN === 'prd'
      ? [
          'danielabohorquez@habi.co',
          'davidboyaca@habi.co',
          'kalethguerrero@habi.co',
          'santiagosalcedo@habi.co',
          'cristianpalacios@tuhabi.mx',
          'felipeuribe@habi.co',
          'lauracanon@habi.co',
        ]
      : DEV_AGENTS;
  },
  get MX() {
    return process.env.ENV_ORIGIN === 'prd'
      ? [
          'alejandrotrujillo@tuhabi.mx',
          'danielhurtado@habi.co',
          'fernandomejia@tuhabi.mx',
          'guadaluperoman@tuhabi.mx',
          'mariaavila@habi.co',
          'marianamarquez@tuhabi.mx',
          'mariorangel@tuhabi.mx',
          'orlandonunez@tuhabi.mx',
          'raulrosales@tuhabi.mx',
          'santiagosalcedo@habi.co',
          'cristianpalacios@tuhabi.mx',
          'felipeuribe@habi.co',
        ]
      : DEV_AGENTS;
  },
};

export const ALL_STATUS_OPTIONS = Object.entries(statusText).map(
  ([value, label]) => ({ value, label })
);

export const getOptionsFromData = (
  data: TaskItem[],
  key: 'agent'
): { label: string; value: string }[] => {
  const values = new Set(data.map(item => item[key] || 'Sin asignar'));
  return Array.from(values).map(value => ({ label: value, value }));
};

export const MILLISECONDS_PER_MINUTE = 60 * 1000;
export const DEFAULT_MINUTES = 1;

export const isOlderThanMinutes = (
  dateString: string,
  minutes = DEFAULT_MINUTES
): boolean => {
  const createdAt = new Date(dateString).getTime();
  if (isNaN(createdAt)) return false;

  const diffInMs = Date.now() - createdAt;
  return diffInMs >= minutes * MILLISECONDS_PER_MINUTE;
};
